import type {
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		/**
		 * The user has published their first page ever in the current session
		 * If they publish more than one page, this condition is invalidated
		 */
		hasMetPublishNudgeConditions: false,
		hasLandInEditorBannerVisible: false,
	},
	actions: {
		setHasMetPublishNudgeConditions:
			(
				hasMetPublishNudgeConditions: boolean,
			): (({
				setState,
			}: StoreActionApi<{
				/**
				 * The user has published their first page ever in the current session
				 * If they publish more than one page, this condition is invalidated
				 */
				hasMetPublishNudgeConditions: boolean;
				hasLandInEditorBannerVisible: boolean;
			}>) => void) =>
			({ setState }) => {
				setState({
					hasMetPublishNudgeConditions,
				});
			},
		setHasLandInEditorBannerVisible:
			(
				hasLandInEditorBannerVisible: boolean,
			): (({
				setState,
			}: StoreActionApi<{
				/**
				 * The user has published their first page ever in the current session
				 * If they publish more than one page, this condition is invalidated
				 */
				hasMetPublishNudgeConditions: boolean;
				hasLandInEditorBannerVisible: boolean;
			}>) => void) =>
			({ setState }) => {
				setState({
					hasLandInEditorBannerVisible,
				});
			},
	},
	name: 'useOnboardingEditorState',
});

export const useOnboardingEditorState: HookStateFunction<
	{
		hasMetPublishNudgeConditions: boolean;
		hasLandInEditorBannerVisible: boolean;
	},
	void
> = createStateHook(Store, {
	selector: (state) => ({
		hasMetPublishNudgeConditions: state.hasMetPublishNudgeConditions,
		hasLandInEditorBannerVisible: state.hasLandInEditorBannerVisible,
	}),
});

export const useOnboardingEditorActions: HookActionsFunction<
	BoundActions<
		{
			/**
			 * The user has published their first page ever in the current session
			 * If they publish more than one page, this condition is invalidated
			 */
			hasMetPublishNudgeConditions: boolean;
			hasLandInEditorBannerVisible: boolean;
		},
		{
			setHasMetPublishNudgeConditions: (hasMetPublishNudgeConditions: boolean) => ({
				setState,
			}: StoreActionApi<{
				/**
				 * The user has published their first page ever in the current session
				 * If they publish more than one page, this condition is invalidated
				 */
				hasMetPublishNudgeConditions: boolean;
				hasLandInEditorBannerVisible: boolean;
			}>) => void;
			setHasLandInEditorBannerVisible: (hasLandInEditorBannerVisible: boolean) => ({
				setState,
			}: StoreActionApi<{
				/**
				 * The user has published their first page ever in the current session
				 * If they publish more than one page, this condition is invalidated
				 */
				hasMetPublishNudgeConditions: boolean;
				hasLandInEditorBannerVisible: boolean;
			}>) => void;
		}
	>
> = createActionsHook(Store);
